import React, { useEffect, useState } from "react";
import {
  Navbar,
  Container,
  Header,
  Text,
  Grid,
} from "rsuite";
import "../../index.css";
import { useLocation, useNavigate } from "react-router-dom";

// import { connect } from "react-redux";
// import { appInsights } from "../../pages/router";
export const WINDOWSIZE = 'WINDOWSIZE'

const MainContainer = (props: any) => {
  // const [graphData, setGraphData] = useState<any>(null);
  const navigate = useNavigate()
  // const location = useLocation()


  return (
    <Navbar id="navbar" className="bg-black px-4 py-2">
      <Grid fluid>
        <div className="flex justify-between items-center">
          <div className="flex-col w-full items-center basis-[80%] grow-1">
            <Text className="font-bold text-white sm:text-[2vh] md:text-[2vh] lg:text-[3.5vh]">
              Deloitte<span className="text-mainGreen">.</span>
            </Text>
            <Text className="text-[#9dd4cf] sm:text-[1.5vh] md:text-[1.5vh] lg:text-[2.5vh] font-bold">
              WDEdge
            </Text>
            <Text className="text-white sm:text-[1.2vh] md:text-[1.2vh] lg:text-[2.5vh] font-normal">
              Take a holistic, AI-enabled approach to drive profitable growth
            </Text>
          </div>
          <div className="flex justify-end items-center basis-[50%]">
            <img src="/header-bg.jpg" className="sm:w-[50%] md:w-[40%] lg:w-[10vw]"></img>
          </div>
        </div>
      </Grid>
    </Navbar>
  );
};


const Headers = (props: any) => {

  const [windowSize, setWindowSize] = useState<any>({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Container>
      <Header>
        <MainContainer />
      </Header>
    </Container>
  );
};

export default Headers;
